import { memo } from "react"
import { CameraName, IconPlay, IconSize, GridCameraName } from "./sxVisualizacaoEvento"
import { DownloadForOffline, PhotoCameraFront, PlayCircleFilled } from "@mui/icons-material"
import { Box, Tooltip } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

const LineVideoPlay = ({ title, handleOpenVideo }) => {
    return (
        <Grid xs={12} container >
            <Grid xs={9} sx={GridCameraName}>
                <Box component='div'><PhotoCameraFront sx={IconSize}/></Box>
                <Box component='div' sx={{ ...CameraName, maxWidth: '100%' }}>{title}</Box>
            </Grid>
            <Grid xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', maxHeight: '20px' }}>
                <Tooltip title={'Em Breve'} placement="left" arrow>
                    <Box component='div' sx={IconPlay}><DownloadForOffline sx={IconSize}/></Box>
                </Tooltip>
                <Tooltip title={'Visualizar'} placement="left" arrow>
                    <Box onClick={handleOpenVideo} component='div'sx={IconPlay}><PlayCircleFilled sx={IconSize}/> </Box>
                </Tooltip>
            </Grid>
        </Grid>
    )
}

export default memo(LineVideoPlay)
